import { cn } from '@/lib/utils'
import { Diamond } from 'lucide-react'

interface KeyframeButtonProps {
  hasKeyframes: boolean
  isAtKeyframe: boolean
  onClick: () => void
  className?: string
}

export function KeyframeButton({ hasKeyframes, isAtKeyframe, onClick, className }: KeyframeButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-5 h-5 flex items-center justify-center rounded transition-colors shrink-0',
        isAtKeyframe
          ? 'text-amber-500 hover:text-amber-400'
          : hasKeyframes
            ? 'text-amber-500/50 hover:text-amber-500'
            : 'text-surface-muted hover:text-surface-foreground',
        className,
      )}
      title={
        isAtKeyframe
          ? 'Remove keyframe at current time'
          : 'Add keyframe at current time'
      }
    >
      <Diamond
        size={11}
        fill={isAtKeyframe ? 'currentColor' : 'none'}
        strokeWidth={2}
      />
    </button>
  )
}
